import createFieldArray from './createFieldArray';
import plain from './structure/plain';

export default createFieldArray(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/FieldArray.js
// module id = 1462
// module chunks = 7